import { makeStyles } from 'tss-react/mui';

import { DESKTOP_BREAK_POINT, MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Header' })((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 80,
        padding: '0 24px',
        boxShadow: '0px 10px 40px rgba(200, 212, 220, 0.35)',
        background: '#fff',
        position: 'relative',
        zIndex: 99,
        [theme.breakpoints.down(DESKTOP_BREAK_POINT)]: {
            minHeight: 66
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            minHeight: 56,
            padding: '0 16px'
        }
    },
    logo: {
        marginRight: 'auto'
    },
    margined: {
        marginLeft: 24,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginLeft: 16
        }
    }
}));
